import { createActions, createReducer } from 'reduxsauce'

import DetalhesRecursoRecebidoService from '../../servicos/DetalhesRecursoRecebidoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaParecerGestorRecursoRecebidoInicio: [],
    buscaParecerGestorRecursoRecebidoSucesso: ['parecerGestorRecursoRecebido'],
    buscaParecerGestorRecursoRecebidoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaParecerGestorRecursoRecebido = filtro => {
    return dispatch => {
        dispatch(Creators.buscaParecerGestorRecursoRecebidoInicio())
        let serv = new DetalhesRecursoRecebidoService()
        return serv
            .consultarParecerGestor(filtro)
            .then(response => dispatch(Creators.buscaParecerGestorRecursoRecebidoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaParecerGestorRecursoRecebidoErro(error)))
    }
}

const buscaParecerGestorRecursoRecebidoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaParecerGestorRecursoRecebidoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaParecerGestorRecursoRecebidoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.parecerGestorRecursoRecebido, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_PARECER_GESTOR_RECURSO_RECEBIDO_INICIO]: buscaParecerGestorRecursoRecebidoInicio,
    [Types.BUSCA_PARECER_GESTOR_RECURSO_RECEBIDO_ERRO]: buscaParecerGestorRecursoRecebidoErro,
    [Types.BUSCA_PARECER_GESTOR_RECURSO_RECEBIDO_SUCESSO]: buscaParecerGestorRecursoRecebidoSucesso,
})
